<div class="carousel-dialog">
    <button class="btn-close" (click)="close()" aria-label="Cerrar galería">×</button>

    <div class="carousel-container">
        <button class="btn-nav left" (click)="prevImage()" aria-label="Imagen anterior">‹</button>

        <img
            [src]="images[currentIndex]?.url"
            [alt]="images[currentIndex]?.name || 'Imagen ' + (currentIndex + 1)"
            class="carousel-image"
        />

        <button class="btn-nav right" (click)="nextImage()" aria-label="Imagen siguiente">›</button>
    </div>

    <div class="carousel-indicator">
        {{ currentIndex + 1 }} / {{ images.length }}
    </div>
</div>
